import { BASE_ADMIN_V2_PATH } from '../../shared/admin/constants/path.constants';

const ADMIN_DELIVERY_POINT_APP_ROOT = `${BASE_ADMIN_V2_PATH}/delivery-points`;

export const ADMIN_DELIVERY_POINT_APP_PATHS = {
  DELIVERY_POINTS_LIST: `${ADMIN_DELIVERY_POINT_APP_ROOT}`,
  DELIVERY_POINT_DETAILS: `${ADMIN_DELIVERY_POINT_APP_ROOT}/:deliveryPointId`,
  DELIVERY_POINT_DETAILS_PATH: (deliveryPointId: string) =>
    `${ADMIN_DELIVERY_POINT_APP_ROOT}/${deliveryPointId}`,
};
